module.exports = __webpack_public_path__ + "img/income-title.65699e31.png";